import Cookies from 'js-cookie';

const getToken = async () => {
  let authToken = Cookies.get('token');
  let userRole = Cookies.get('userRole');
  if (!authToken) {
    // Logic to fetch and set token if not available
    // This could involve making a request to get a new token
    authToken = Cookies.get('token'); // Implement this function based on your auth flow
    Cookies.set('token', authToken);
  }
  // return `${authToken}?role=${userRole}`;
  return authToken;
};

export const getHeaders = async () => {
  const token = await getToken();
  const userRole = Cookies.get('userRole');
  const sessionId = Cookies.get('sessionId');
  const headers = {
    authorization: `${token}`
    // role: userRole
  };
  if (sessionId) {
    headers['x-session-id'] = sessionId;
  }
  return { headers };
};

export const getFileHeaders = async () => {
  const token = await getToken();
  const sessionId = Cookies.get('sessionId');
  const headers = {
    authorization: `${token}`,
    Accept: 'application/pdf',
    'Content-Type': 'application/pdf'
  };
  if (sessionId) {
    headers['x-session-id'] = sessionId;
  }
  return { headers };
};

export const getExcelHeaders = async () => {
  const token = await getToken();
  const sessionId = Cookies.get('sessionId');
  const headers = {
    authorization: `${token}`,
    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  };
  if (sessionId) {
    headers['x-session-id'] = sessionId;
  }
  return { headers };
};
